import { AppBar, DefaultEndArea } from "@facade/shared";
import { PropsWithChildren, Suspense, useEffect, useState } from "react";

import { ProjectAppBarStartContent } from "./ProjectAppBarStartContent";
import { SideBarContext } from "../../contexts";

const SIDEBAR_STORAGE_KEY = "floorbit.project-sidebar.open";

function getInitialSidebarState() {
  if (typeof window === "undefined") {
    return true;
  }

  const storedValue = window.localStorage.getItem(SIDEBAR_STORAGE_KEY);

  if (storedValue === null) {
    return true;
  }

  return storedValue === "true";
}

export const ViewProjectLayout = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState<boolean>(getInitialSidebarState);

  useEffect(() => {
    window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(isOpen));
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen((currentValue) => !currentValue);
  };

  return (
    <SideBarContext
      value={{
        open: isOpen,
        toggle() {
          handleToggle();
        },
      }}
    >
      <AppBar
        slots={{
          start: (
            <Suspense>
              <ProjectAppBarStartContent />
            </Suspense>
          ),
          center: null,
          end: <DefaultEndArea />,
        }}
      />

      {children}
    </SideBarContext>
  );
};
